import clsx from 'clsx'
import React, {useContext} from 'react'
import {hasActiveStandardsFilter} from 'components/standards-selector/domain/active-filters.cjs'
import {Link, useLocation} from 'react-router-dom'
import SearchPattern from 'components/search-pattern'
import Box from '@mui/material/Box'


import {TeacherContext} from 'teacher/context'

export default function PatternFilter (props) {

  const {classes, onChange} = props
  const location = useLocation()
  const context = useContext(TeacherContext)
  const {tab, link, linkQuery, query, translate, quizQuestionTypes: questionTypes} = context

  return (
    <Box className={classes.patternFilter}>
      <Box className={classes.patternInput}>
        <SearchPattern path={location.pathname} context={context} />
      </Box>
      {!hasActiveStandardsFilter(context.quizStandardFilters) && <Box className={classes.standardsSearch}>
        <Link to={linkQuery(`${location.pathname}/standards-search`)} className={classes.standardsSearchLink}>
          {translate('standards-search')}
        </Link>
      </Box>}
    </Box>
  )
}
